// extracted by mini-css-extract-plugin
module.exports = {"result":"result__styles-module--PhE6a","title":"title__styles-module--95bYu"};